export default __webpack_public_path__ + "2dec10e8254b2591098b02811da5bf78.svg";